import React from 'react';
import { useParams } from 'react-router';

import { url } from 'helpers';
import { useInvoiceQuery } from 'hooks/queries';
import { SinglePage } from 'components/layout';
import { Uuid } from 'types/common';

import View from './View';

const InvoicePage = () => {
  const params = useParams();

  const invoiceQuery = useInvoiceQuery(params.invoiceId as Uuid);

  return (
    <SinglePage
      query={invoiceQuery}
      returnUrl={url.toInvoices()}
      render={(invoice) => <View invoice={invoice} />}
    />
  );
};

export default InvoicePage;
